import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _Slider2 from "element-ui/lib/theme-chalk/slider.css";
import "element-ui/lib/theme-chalk/base.css";
import _Slider from "element-ui/lib/slider";
import _Image2 from "element-ui/lib/theme-chalk/image.css";
import "element-ui/lib/theme-chalk/base.css";
import _Image from "element-ui/lib/image";
const element = {
  install: function (Vue) {
    Vue.use(_Image);
    Vue.use(_Slider);
    // Vue.use(Loading)

    Vue.prototype.$msgbox = _MessageBox;
    Vue.prototype.$alert = _MessageBox.alert;
    Vue.prototype.$confirm = _MessageBox.confirm;
    Vue.prototype.$prompt = _MessageBox.prompt;
    Vue.prototype.$loading = _Loading;
    Vue.prototype.$message = _Message;
  }
};
export default element;